<div
	*ngIf="plakaGoster == true"
	class="kt-header__topbar-item kt-header__topbar-item--quick-panel"
	data-placement="bottom"
	ngbTooltip="Farklı bir plaka için randevu girişi"
	(click)="redirectTo()"
>
	<button class="btn btn-sm btn-secondary" style="font-size: 13px; font-weight: 700; color: #9fa1ae">Yeni Plaka</button>
</div>
